import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type ShareAssetFieldInfo_CollectionField_Fragment = { __typename?: 'CollectionField', isFrozen?: boolean | null, isVisible?: boolean | null, width?: number | null, fieldDefinition?: { __typename?: 'ProjectFieldDefinition', id: string, name: string } | null };

export type ShareAssetFieldInfo_ShareField_Fragment = { __typename?: 'ShareField', isFrozen?: boolean | null, isVisible?: boolean | null, width?: number | null, fieldDefinition?: { __typename?: 'ProjectFieldDefinition', id: string, name: string } | null };

export type ShareAssetFieldInfoFragment = ShareAssetFieldInfo_CollectionField_Fragment | ShareAssetFieldInfo_ShareField_Fragment;

export type AssetAggregateHeader_AdHocAssetsShare_Fragment = { __typename?: 'AdHocAssetsShare', name: string, aggregationMode: Types.AssetAggregateAggregationModeEnum, appearance: { __typename?: 'AssetAggregateAppearance', hasHeader: boolean, layout: Types.AssetAggregateLayoutEnum, header?: { __typename?: 'AssetAggregateAppearanceHeader', description?: string | null, iconEmoji?: string | null, isBackgroundEnabled?: boolean | null, isCreatorInfoEnabled?: boolean | null, isDescriptionEnabled?: boolean | null, isIconEnabled?: boolean | null, size?: Types.AssetAggregateHeaderSizeEnum | null, backgroundImage?: { __typename?: 'AssetAggregateBackgroundImage', url?: string | null, relativePosition?: number | null, blurhash?: string | null, imageSource?: Types.BackgroundImageSource | null } | null, iconImage?: { __typename?: 'AssetAggregateIconImage', url?: string | null } | null, iconImages?: { __typename?: 'Images', image128?: string | null } | null } | null } };

export type AssetAggregateHeader_Collection_Fragment = { __typename?: 'Collection', name: string, aggregationMode: Types.AssetAggregateAggregationModeEnum, appearance: { __typename?: 'AssetAggregateAppearance', hasHeader: boolean, layout: Types.AssetAggregateLayoutEnum, header?: { __typename?: 'AssetAggregateAppearanceHeader', description?: string | null, iconEmoji?: string | null, isBackgroundEnabled?: boolean | null, isCreatorInfoEnabled?: boolean | null, isDescriptionEnabled?: boolean | null, isIconEnabled?: boolean | null, size?: Types.AssetAggregateHeaderSizeEnum | null, backgroundImage?: { __typename?: 'AssetAggregateBackgroundImage', url?: string | null, relativePosition?: number | null, blurhash?: string | null, imageSource?: Types.BackgroundImageSource | null } | null, iconImage?: { __typename?: 'AssetAggregateIconImage', url?: string | null } | null, iconImages?: { __typename?: 'Images', image128?: string | null } | null } | null } };

export type AssetAggregateHeader_CollectionShare_Fragment = { __typename?: 'CollectionShare', name: string, aggregationMode: Types.AssetAggregateAggregationModeEnum, appearance: { __typename?: 'AssetAggregateAppearance', hasHeader: boolean, layout: Types.AssetAggregateLayoutEnum, header?: { __typename?: 'AssetAggregateAppearanceHeader', description?: string | null, iconEmoji?: string | null, isBackgroundEnabled?: boolean | null, isCreatorInfoEnabled?: boolean | null, isDescriptionEnabled?: boolean | null, isIconEnabled?: boolean | null, size?: Types.AssetAggregateHeaderSizeEnum | null, backgroundImage?: { __typename?: 'AssetAggregateBackgroundImage', url?: string | null, relativePosition?: number | null, blurhash?: string | null, imageSource?: Types.BackgroundImageSource | null } | null, iconImage?: { __typename?: 'AssetAggregateIconImage', url?: string | null } | null, iconImages?: { __typename?: 'Images', image128?: string | null } | null } | null } };

export type AssetAggregateHeaderFragment = AssetAggregateHeader_AdHocAssetsShare_Fragment | AssetAggregateHeader_Collection_Fragment | AssetAggregateHeader_CollectionShare_Fragment;

export const ShareAssetFieldInfo = /*#__PURE__*/ gql`
    fragment ShareAssetFieldInfo on AssetAggregateField {
  fieldDefinition {
    id
    name
  }
  isFrozen
  isVisible
  width
}
    ` as unknown as DocumentNode<ShareAssetFieldInfoFragment, unknown>;
export const AssetAggregateHeader = /*#__PURE__*/ gql`
    fragment AssetAggregateHeader on AssetAggregate {
  name
  aggregationMode
  appearance {
    hasHeader
    header {
      backgroundImage {
        url
        relativePosition
        blurhash
        imageSource
      }
      description
      iconEmoji
      iconImage {
        url
      }
      iconImages {
        image128
      }
      isBackgroundEnabled
      isCreatorInfoEnabled
      isDescriptionEnabled
      isIconEnabled
      size
    }
    layout
  }
}
    ` as unknown as DocumentNode<AssetAggregateHeaderFragment, unknown>;

        

        
export const useShareAssetFieldInfoFragment = (
  input: string | Omit<UseFragmentOptions<ShareAssetFieldInfoFragment, any>, 'fragment' | 'fragmentName'> | undefined | null
) => {
  const options = (() => {
    if (!input) return { from: null };
    if (typeof input === 'string') return { from: { id: input, __typename: 'AssetAggregateField' } };
    return input;
  })();

  return useFragment<ShareAssetFieldInfoFragment>({
    fragment: ShareAssetFieldInfo,
    fragmentName: 'ShareAssetFieldInfo',
    ...options,
  });
};
  
        
        

        
export const useAssetAggregateHeaderFragment = (
  input: string | Omit<UseFragmentOptions<AssetAggregateHeaderFragment, any>, 'fragment' | 'fragmentName'> | undefined | null
) => {
  const options = (() => {
    if (!input) return { from: null };
    if (typeof input === 'string') return { from: { id: input, __typename: 'AssetAggregate' } };
    return input;
  })();

  return useFragment<AssetAggregateHeaderFragment>({
    fragment: AssetAggregateHeader,
    fragmentName: 'AssetAggregateHeader',
    ...options,
  });
};
  
        